module.exports = __webpack_public_path__ + "img/productinfo-2.f7be68f5.jpg";